const STATUS_ACTIVE = "ACTIVE";

const LABEL_EXPIRED = "Expired";

const COLOR_ACTIVE = "green";
const COLOR_REVOKED = "red";
const COLOR_EXPIRED = "orange";

export type StatusTag = {
  color: string;
  label: string;
};

type Props = {
  status: string;
  expiresAt: string;
};

// NOTE: a token that passes its expiration keeps the ACTIVE status, because
//       no operation writes the record at that moment. The tag gives the
//       expiration first, therefore the reader sees the state of the token
//       and not the state of the record.
const getStatusTag = ({ status, expiresAt }: Props): StatusTag => {
  const isRevoked = status !== STATUS_ACTIVE;

  if (isRevoked) {
    const revokedTag = {
      color: COLOR_REVOKED,
      label: status,
    };

    return revokedTag;
  }

  const isExpired = new Date(expiresAt).getTime() < Date.now();

  if (isExpired) {
    const expiredTag = {
      color: COLOR_EXPIRED,
      label: LABEL_EXPIRED,
    };

    return expiredTag;
  }

  const statusTag = {
    color: COLOR_ACTIVE,
    label: status,
  };

  return statusTag;
};

export default getStatusTag;
